import { queryKey } from "../api/endpoints";
import type { Id, Mode } from "../api/types";

/** The conversation keys of 2.7.1. */
export const conversationKeys = {
  session: (sessionId: Id) => `session:${sessionId}`,
  sme: (membershipId: Id) => `sme:${membershipId}`,
  explain: (membershipId: Id) => `explain:${membershipId}`,
  tutor: (membershipId: Id) => `tutor:${membershipId}`,
  admin: (personId: Id) => `admin:${personId}`,
  adminOnboarding: (personId: Id) => `admin_onboarding:${personId}`,
} as const;

/** The admin's conversations have their own endpoints: the admin has no discipline (15.1). */
export function isAdminMode(mode: Mode): boolean {
  return mode === "admin" || mode === "admin_onboarding";
}

/** The session id in a session's conversation key, or null. */
export function sessionIdOf(key: string): string | null {
  return key.startsWith("session:") ? key.slice("session:".length) || null : null;
}

/** The query key of a conversation, for reading it again. */
export function conversationQueryKey(key: string, admin: boolean) {
  return (admin ? queryKey("admin_conversation", { key }) : queryKey("conversation", { key })) as unknown as readonly unknown[];
}
